import { Container } from "react-bootstrap";

function PrivacyPolicy() {
  return (
    <Container>
      <div style={{ overflowX: "hidden", fontFamily: "" }} dir="rtl" lang="ar">
        <br />
        <br />
        <h1>سياسات الخصوصية:</h1>
        <br />
        <br />
        <p>
          لا نقوم بجمع أو استخدام أي بيانات شخصية من المتاعملين على صفحة الموقع
          أو التطبيق سواء على منصة أبل أو أندرويد
        </p>

        <br />
        <p>للتواصل معنا: ali.elhall@gmail.com</p>
        <p>
          الأسعار في الصفحة إرشادية فقط و لا يمكن البناء عليها في أي عمليات
          تجارية أو في البيع أو الشراء لأي نوع من أنواع السلع أو العملات
        </p>
      </div>
      <br />
      <br />
      <br />
      <div style={{ overflowX: "hidden", fontFamily: "" }} dir="ltr" lang="en">
        <h1>Privacy policy</h1>
        <p>
          We do not collect or use any personal data from customers on the
          website or application page, whether on the Apple or Android platform
        </p>
        <p>To contact us: ali.elhall@gmail.com</p>
        <p>
          The prices on the page are indicative only and cannot be relied upon
          in any commercial transactions or in the sale or purchase of any type
          of commodity or currency
        </p>
      </div>
    </Container>
  );
}

export default PrivacyPolicy;
